// Common
import config from '@/config.js';
// i18n
import i18n from '@/i18n';
// Vuex
import store from '@/store.js';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
// axios
import axios from 'axios';
// consts
import consts from "@/consts.js";

import request_configs from './request_configs'

axios.defaults.baseURL = request_configs.BaseURL;// 接口域名

const CancelToken = axios.CancelToken;
const requests = new Map();

export default async function Request(method, url, data, noLoading, noResponseError, noCancel) {
    request_configs.Headers["access-token"] = localStorage.getItem("accessToken");
    request_configs.Headers["locale"] = i18n.locale;
    request_configs.Headers["debug"] = config.debug;

    if(!noCancel) {
        var lastRequest = requests.get(url);
        if (lastRequest) {
            lastRequest.cancel("Cancel Last Request.");
            requests.delete(url);
        }
    }
    if (!noLoading) store.dispatch("threadLoadingStart");// loading计数+1
    try {
        method = method.toLowerCase();
        let source;
        if (method === 'get') {// 只对get方法支持cancel
            source = CancelToken.source();
            requests.set(url, source);
        }
        if(data && data.itemsPerPage == -1) data.limit =consts.limitAll; //获取全部
        data = (method === 'get' || method === 'delete' || method === 'head') ?
            {
                params: data,
                cancelToken: source ? source.token : null,
                headers: request_configs.Headers
            } : data;
        return new Promise((resolve, reject) => {
            axios[method](url, data, {
                cancelToken: source ? source.token : null,
                headers: request_configs.Headers
            })
                .then(response => {
                    // console.log('response resolve');
                    if (response.data && response.data.status) {
                        // 对 data 进行预处理，判断是否要登出
                        if ('NG' == response.data.status) {
                            if (response.data.error != null && 'ERR001' == response.data.error.code) {//登录错误不显示snackbar
                                store.commit("LOGOUT");
                            } else if (!noResponseError//未禁用后台error统一显示
                                && 'ERR002' != response.data.error.code//账号密码错误也不显示snackbar
                                // && !('ERR333' == response.data.error.code && response.data.error.data)//validate失败若是给了详细报错则不显示snackbar
                                && 'ERR099' != response.data.error.code//当前页码无数据也不显示snackbar
                            ) {
                                snackbar.handleError(response.data.error);
                            }
                        }
                    } else {
                        console.log("API ERROR: ", response);
                        snackbar.error("API ERROR: INVALID RESPONSE.");
                    }
                    if (config.debug)
                        console.log(response.data);// for local debug
                    resolve(response);
                    if (!noLoading) store.dispatch("threadLoadingStop");// loading计数-1
                }, error => {
                    if (!axios.isCancel(error)) {
                        console.log('HTTP RESPONSE ERROR: ', error);
                        snackbar.error(i18n.t("RequestError"));
                        reject(error);
                    }
                    if (!noLoading) store.dispatch("threadLoadingStop");// loading计数-1
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        console.log('HTTP REQUEST ERROR: ', error);
                        snackbar.error(i18n.t("RequestError"));
                        reject(error);
                    }
                    if (!noLoading) store.dispatch("threadLoadingStop");// loading计数-1
                });
        });
    } catch (error) {
        console.log("HTTP ERROR: ", error);
        snackbar.error(error);
        if (!noLoading) store.dispatch("threadLoadingStop");// loading计数-1
        return Promise.reject(error);
    }
}